import React from 'react';

interface MoneyInputProps {
  value: number | null;
  onChange: (value: number | null) => void;
  placeholder?: string;
  minWidth?: string;
  disabled?: boolean;
  className?: string;
}

export const MoneyInput: React.FC<MoneyInputProps> = ({
  value,
  onChange,
  placeholder = '0.00',
  minWidth = '60px',
  disabled = false,
  className = '',
}) => {
  const [inputValue, setInputValue] = React.useState(value?.toString() ?? '');

  React.useEffect(() => {
    setInputValue(value?.toString() ?? '');
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;

    if (newValue === '') {
      onChange(null);
      setInputValue('');
      return;
    }

    // If valid, set the value
    if (/^-?\d*\.?\d+$|^-?\d+\.?\d*$/.test(newValue)) {
      const parsed = Number(parseFloat(newValue).toFixed(2));
      if (!isNaN(parsed)) {
        onChange(parsed);
        setInputValue(newValue);
      } else {
        onChange(null);
        setInputValue('');
      }
    }
  };

  return (
    <input
      type="text"
      className={`form-control-sm ${className}`}
      value={inputValue}
      onChange={handleChange}
      style={{
        minWidth,
        maxWidth: '100px',
        textAlign: 'right',
        width: 'auto',
        padding: '0.25rem 0.5rem',
      }}
      placeholder={placeholder}
      disabled={disabled}
    />
  );
};

export const MoneyDisplay: React.FC<{
  value: number | null | undefined;
  currency: string;
  showEmpty?: boolean;
}> = ({ value, currency, showEmpty = false }) => {
  if (!showEmpty && (value === null || value === undefined)) {
    return null;
  }
  return (
    <>
      {currency} {value ?? 0}
    </>
  );
};
